import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createExpense } from '../../api/finance';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://kanguroo-crm-production.up.railway.app/api/v1';
const api = axios.create({ baseURL: API_BASE });
api.interceptors.request.use((c) => { const t = localStorage.getItem('token'); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });

const CATEGORIES = [
  { value: 'ads', label: 'Reklam Harcamasi' },
  { value: 'freelancer', label: 'Freelancer / Taseron' },
  { value: 'salary', label: 'Maas' },
  { value: 'software', label: 'Yazilim Aboneligi' },
  { value: 'office', label: 'Ofis Gideri' },
  { value: 'tax', label: 'Vergi / SGK' },
  { value: 'other', label: 'Diger' },
];

export default function ExpenseForm() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    title: '', vendor_name: '', customer_id: '', deal_id: '',
    category: 'other', amount: '', currency: 'TRY',
    expense_date: new Date().toISOString().split('T')[0],
    due_date: '', invoice_document_url: '', notes: '',
  });

  useEffect(() => {
    api.get('/customers/').then((r) => setCustomers(r.data)).catch(() => {});
    api.get('/deals/').then((r) => setDeals(r.data)).catch(() => {});
  }, []);

  const set = (f, v) => setForm((p) => ({ ...p, [f]: v }));

  const handleSubmit = async () => {
    if (!form.title) return alert('Baslik zorunludur');
    if (!form.amount || isNaN(parseFloat(form.amount))) return alert('Gecerli bir tutar giriniz');
    if (!form.expense_date) return alert('Tarih zorunludur');
    setLoading(true);
    try {
      await createExpense({
        ...form,
        amount: parseFloat(form.amount),
        customer_id: form.customer_id || null,
        deal_id: form.deal_id || null,
        due_date: form.due_date || null,
        invoice_document_url: form.invoice_document_url || null,
      });
      alert('Gider eklendi, onay icin yoneticiye iletildi');
      navigate('/finance/expenses');
    } catch (e) { alert(e?.response?.data?.detail || 'Hata'); } finally { setLoading(false); }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="text-gray-400 hover:text-gray-700 text-xl">←</button>
        <h1 className="text-2xl font-bold text-gray-900">Yeni Gider</h1>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800">
        <strong>Not:</strong> Girilen gider otomatik olarak yonetici onayina gonderilecektir.
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-5 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-600 mb-1">Baslik *</label>
            <input type="text" value={form.title} onChange={(e) => set('title', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Örn: Meta Reklam - Marka X Mayis 2025" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Tedarikci</label>
            <input type="text" value={form.vendor_name} onChange={(e) => set('vendor_name', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Örn: Adobe Inc." />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Kategori *</label>
            <select value={form.category} onChange={(e) => set('category', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              {CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Musteri (opsiyonel)</label>
            <select value={form.customer_id} onChange={(e) => set('customer_id', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Genel gider</option>
              {customers.map((c) => <option key={c.id} value={c.id}>{c.company_name || c.full_name}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Deal (opsiyonel)</label>
            <select value={form.deal_id} onChange={(e) => set('deal_id', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Deal secin</option>
              {deals.map((d) => <option key={d.id} value={d.id}>{d.title}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Tutar *</label>
            <input type="number" value={form.amount} onChange={(e) => set('amount', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="0.00" min="0" step="0.01" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Para Birimi</label>
            <select value={form.currency} onChange={(e) => set('currency', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="TRY">TRY</option><option value="USD">USD</option><option value="EUR">EUR</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Gider Tarihi *</label>
            <input type="date" value={form.expense_date} onChange={(e) => set('expense_date', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Odeme Vadesi</label>
            <input type="date" value={form.due_date} onChange={(e) => set('due_date', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-600 mb-1">Fatura Belgesi URL</label>
            <input type="text" value={form.invoice_document_url} onChange={(e) => set('invoice_document_url', e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="https://drive.google.com/..." />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium text-gray-600 mb-1">Notlar</label>
            <textarea value={form.notes} onChange={(e) => set('notes', e.target.value)} rows={2}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
        </div>
      </div>

      <div className="flex gap-3 justify-end">
        <button onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition">Iptal</button>
        <button onClick={handleSubmit} disabled={loading}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50 transition">
          {loading ? 'Kaydediliyor...' : 'Gider Ekle ve Onaya Gonder'}
        </button>
      </div>
    </div>
  );
}
